<template>
  <div class="loginall">
    <div class="login">
       <img src="../assets/icon1.png" alt="">
       <div class="title">登录</div>
       <div class="welcome">欢迎登录!</div>
    </div>
    <div class="loginFuc">
        <div :class="isPasswordLogin?'active':''" @click="passwordLogin">密码登录</div>
        <div :class="!isPasswordLogin?'active':''" @click="codeLogin">验证码登录</div>
    </div>
    <el-form
      v-if="isPasswordLogin"
      :model="passwordLoginForm"
      :rules="rulesPasswordLogin"
      ref="passwordLoginForm">
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="account"
        >
          <el-row>
            <el-col :span='5'>
              <img class="iconimg" src="../assets/icon2.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="passwordLoginForm.account"
                placeholder="请输入手机号或邮箱"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="password"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon3.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                type="password"
                v-model="passwordLoginForm.password"
                placeholder="请输入密码"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-button @click="login('passwordLoginForm')">登录</el-button>
    </el-form>
    <el-form
      v-else
      key="phoneCode"
      :model="codeLoginForm"
      :rules="rulesCodeLogin"
      ref="codeLoginForm">
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="accountOfCode"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon2.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="codeLoginForm.accountOfCode"
                placeholder="请输入手机号或邮箱"
                clearable
              ></el-input>
            </el-col>
            <el-col class="inputpass" :span='6'>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="code"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon4.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='13'>
              <el-input
                v-model="codeLoginForm.code"
                placeholder="请输入验证码"
                maxlength="6"
                onkeyup="value = value.replace(/[^\d]/g, '')"
                clearable
              ></el-input>
            </el-col>
            <el-col class="inputpass" :span='6'>
                <el-link @click="onCode" style="color:#ffb949; margin-bottom:5px">{{codeText}}</el-link>
            </el-col>
          </el-row>
        </el-form-item>
        <div class="registerTip">* 如果手机号未注册，将直接完成注册</div>
        <el-button @click="login('codeLoginForm')">登录</el-button>
    </el-form>
    <div class="register">
        <span><router-link to="/rePassword">忘记密码</router-link></span>
        <span>|</span>
        <span><router-link to="/register">注册</router-link></span>
    </div>
  </div>
</template>

<script>
import http from '../utils/http'

export default {
  name: 'login',
  data () {
    return {
      isPasswordLogin: true,
      codeText: '获取验证码',
      myTime: null,
      phoneRex: /^\d{11}$/,
      emailRex: /^[^@]+@[^.]+\..+$/,
      passwordLoginForm: {
        account: '',
        password: ''
      },
      codeLoginForm: {
        accountOfCode: '',
        code: ''
      },
      rulesPasswordLogin: {
        account: [
          { required: true, message: '请输入手机号或邮箱', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码至少为6位', trigger: 'blur' }
        ]
      },
      rulesCodeLogin: {
        accountOfCode: [
          { required: true, message: '请输入手机号或邮箱', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '请输入6位数字验证码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    login (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false
        }
        this.doLogin()
      })
    },
    doLogin () {
      if (this.isPasswordLogin) {
        // 密码登录
        const account = this.passwordLoginForm.account
        const password = this.passwordLoginForm.password
        if (this.phoneRex.test(account)) {
          // 手机密码登录
          http['post']('auth/login/phone', {
            phone: account,
            password: password
          }).then((res) => {
            localStorage.setItem('token', res.token)
            this.$router.push({name: 'IndexPage'})
          })
        } else if (this.emailRex.test(account)) {
          // 邮箱密码登录
          http['post']('auth/login/email', {
            email: account,
            password: password
          }).then((res) => {
            localStorage.setItem('token', res.token)
            this.$router.push({name: 'IndexPage'})
          })
        } else {
          this.$message.error('请输入正确的手机号或邮箱')
        }
      } else {
        // 验证码登录
        const account = this.codeLoginForm.accountOfCode
        const code = this.codeLoginForm.code
        if (this.phoneRex.test(account)) {
          // 手机验证码登录
          http['post']('auth/login/code/phone', {
            phone: account,
            code: code
          }).then((res) => {
            localStorage.setItem('token', res.token)
            this.$router.push({name: 'IndexPage'})
          })
        } else if (this.emailRex.test(account)) {
          // 邮箱验证码登录
          http['post']('auth/login/code/email', {
            email: account,
            code: code
          }).then((res) => {
            localStorage.setItem('token', res.token)
            this.$router.push({name: 'IndexPage'})
          })
        } else {
          this.$message.error('请输入正确的手机号或邮箱')
        }
      }
    },
    async onCode () {
      this.$refs['codeLoginForm'].validateField('accountOfCode', (errorMessage) => {
        if (errorMessage) {
          return
        }
        const account = this.codeLoginForm.accountOfCode
        if (this.phoneRex.test(account)) {
          // 手机验证码
          const data = {
            phone: account,
            type: 'login'
          }
          http['post']('auth/request_code/phone', data).then(async () => {
            await this.setTime(60 * 1000)
          }).catch((err) => {
            this.$message.error(err)
          })
        } else if (this.emailRex.test(account)) {
          // 邮箱验证码
          const data = {
            email: account,
            type: 'login'
          }
          http['post']('auth/request_code/email', data).then(async () => {
            await this.setTime(60 * 1000)
          }).catch((err) => {
            this.$message.error(err)
          })
        } else {
          this.$message.error('请输入正确的手机号或邮箱')
        }
      })
    },
    // set 倒计时
    setTime (time) {
      return new Promise((resolve, reject) => {
        if (this.myTime) return
        this.codeText = time / 1000 + '秒'
        this.myTime = setInterval(() => {
          time = time - 1000
          this.codeText = time / 1000 + '秒'
          if (time < 0) {
            clearInterval(this.myTime)
            this.myTime = null
            this.codeText = '获取验证码'
            resolve()
          }
        }, 1000)
      })
    },
    passwordLogin () {
      this.$refs.codeLoginForm.clearValidate()
      this.isPasswordLogin = true
    },
    codeLogin () {
      this.$refs.passwordLoginForm.clearValidate()
      this.isPasswordLogin = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loginall {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.login img {
    width: 100%;
}
.login .title {
  position: relative;
  top: -12rem;
  font-family: "PingFang-SC-Medium";
  font-size: 22px;
  text-align: center;
  color: #fff;
}
.login .welcome {
    position: relative;
    top: -7rem;
    font-family: "PingFang-SC-Medium";
    font-size: 22px;
    text-align: center;
    color: #fff;
}
.loginFuc {
    margin-bottom: 60px;
    display: flex;
    justify-content: center;
}
.loginFuc div {
    padding: 1rem 2.4rem;
    font-family: "PingFang-SC-Medium";
    font-size: 18px;
    color: #666;
}
.active {
    color: #ffb949!important;
    border-bottom: 2px solid #ffb949;
}
.loginPassword {
    display: flex;
    justify-content: center;
    width: 70%;
    border-bottom: 1px solid #e6e6e6;
}
.inputpass>>>.el-input__inner {
  border: 0;
}
.iconimg {
    width: 30px;
    height: 30px;
    margin-left: 10px;
}
.loginall button {
    width: 18rem;
    height: 3.5rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    margin: 3rem 0 1rem;
    color: #fff;
    font-size: 18px;
}
.register {
  margin-bottom: 3rem;
  color:#666;
}
.registerTip {
  color:#999;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/login/login.vue